import { FailedBill } from "@smartrr/shared/entities/Billing";
import { IPurchaseState } from "@smartrr/shared/entities/PurchaseState";
import { create } from "zustand";

import { SmartrrApi } from "@customer-app/api";
import { StatusCodes } from "http-status-codes";

interface BillStore {
  loading: boolean;
  failedBills: FailedBill[];

  actions: {
    loadFailedBills(purchaseState: IPurchaseState): Promise<void>;
  };
}

export const useBillStore = create<BillStore>()(set => ({
  loading: false,
  failedBills: [],

  actions: {
    async loadFailedBills(purchaseState: IPurchaseState): Promise<void> {
      set({
        loading: true,
      });

      const response = await SmartrrApi.bills.getLatest({
        params: {
          paymentMethodId: purchaseState.pmtMth.id,
        },
      });

      if (response.status === StatusCodes.OK) {
        const willLatestBillAutoRetry = response.body.data.length && response.body.data[0].willAutoRetry;
        const failedBills = response.body.data
          .filter(bill => bill.error)
          .map(bill => {
            return {
              id: bill.id,
              error: bill.error,
              retryCount: bill.retryCount,
            } satisfies FailedBill;
          });

        set({
          failedBills: willLatestBillAutoRetry ? failedBills : [],
        });
      }

      set({
        loading: false,
      });
    },
  },
}));
